import { HttpService } from './axios-httpService'

export const authenticateUser = async (code) => {
  const payload = {
    discordCode: code,
  }

  let response = null
  try {
    response = await HttpService.postAuth(payload)
  } catch (error) {
    throw new Error('Authentication failed')
  }

  const data = response.data
  const expirationTime = new Date().getTime() + 2 * 60 * 60 * 1000
  localStorage.setItem('userData', JSON.stringify(data))
  localStorage.setItem('expirationTime', expirationTime)
  return data
}

export const checkTokenValidity = () => {
  const expirationTime = localStorage.getItem('expirationTime')
  if (!expirationTime || new Date().getTime() > expirationTime) {
    handleLogout()
  }
}

export const handleLogout = () => {
  if (localStorage.getItem('userData')) {
    localStorage.clear()
    window.location.replace('/')
  }
}

const timestamp = Number(localStorage.getItem('expirationTime'))
const date = new Date(timestamp)
console.log(date.toLocaleString())

export const setupAutoLogout = () => {
  const expirationTime = localStorage.getItem('expirationTime')
  if (expirationTime) {
    const timeLeft = expirationTime - new Date().getTime()
    const timer = setTimeout(() => {
      handleLogout()
    }, timeLeft)
    return () => clearTimeout(timer)
  }
}

export const isAuthenticated = () => {
  const userData = localStorage.getItem('userData')
  const expirationTime = Number(localStorage.getItem('expirationTime'))
  return userData && expirationTime && new Date().getTime() < expirationTime
}

export const isServerSelected = () => {
  const guildId = localStorage.getItem('guildId')
  return !!guildId
}
